import { gsap } from "gsap";
import { ScrollTrigger} from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

let mm = gsap.matchMedia();
const sections = gsap.utils.toArray('.new-pin');
const bottom = gsap.utils.toArray('.pin')

mm.add("(min-width: 800px)", () => {
  
  sections.forEach((element) => {
    gsap.to(sections, {
      scrollTrigger: {
        trigger: element,
        start: 'top top',
        end: 'clamp(bottom -160)',
        pin: true,
        pinSpacing: false,
        scrub: 1
        // snap: 1 / 3
      }
    })
  });

  bottom.forEach((element) => {
    gsap.to(bottom, {
      scrollTrigger: {
        trigger: element,
        start: 'top top',
        end: 'clamp(bottom top)',
        pin: true,
        pinSpacing: false,
        scrub: 1,
        snap: 1 / 3,
        marker: true
      }
    })
  });


});

